import React, { useState } from 'react';
import { Copy, Trash2, CopyPlus, ArrowRightLeft, Palette } from 'lucide-react';
import TurnIntoSubmenu from './TurnIntoSubmenu';
import BlockColorSubmenu from './BlockColorSubmenu';
import {
  turnIntoParagraph,
  turnIntoHeading,
  turnIntoBulletList,
  turnIntoNumberedList,
  turnIntoQuote,
  turnIntoCode,
  turnIntoCallout,
  turnIntoToggle,
  duplicateBlock,
  deleteBlock,
  copyBlockContent,
} from '../utils/blockTransformUtils';
import { applyBlockTextColor, applyBlockBackgroundColor } from '../utils/colorUtils';
import { getPageEditor } from '../utils/editorStore';
import { useDispatch } from 'react-redux';
import { togglePopover } from '../../../redux/Slices/popoverSlice';
import './scss/BlockActionMenuPopover.scss';

const BlockActionMenuPopover = ({ blockNodeKey, blockType }) => {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const dispatch = useDispatch();
  const editor = getPageEditor();

  const closePopover = () => {
    dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
  };

  const handleDelete = () => {
    deleteBlock(editor, blockNodeKey);
    closePopover();
  };

  const handleDuplicate = () => {
    duplicateBlock(editor, blockNodeKey);
    closePopover();
  };

  const handleCopy = () => {
    copyBlockContent(editor, blockNodeKey);
    closePopover();
  };

  const handleTurnInto = (type) => {
    closePopover();

    switch (type) {
      case 'paragraph':
        turnIntoParagraph(editor, blockNodeKey);
        break;
      case 'h1':
        turnIntoHeading(editor, blockNodeKey, 'h1');
        break;
      case 'h2':
        turnIntoHeading(editor, blockNodeKey, 'h2');
        break;
      case 'h3':
        turnIntoHeading(editor, blockNodeKey, 'h3');
        break;
      case 'bullet':
        turnIntoBulletList(editor, blockNodeKey, blockType);
        break;
      case 'number':
        turnIntoNumberedList(editor, blockNodeKey, blockType);
        break;
      case 'quote':
        turnIntoQuote(editor, blockNodeKey);
        break;
      case 'code':
        turnIntoCode(editor, blockNodeKey);
        break;
      case 'callout':
        turnIntoCallout(editor, blockNodeKey, 'info');
        break;
      case 'toggle':
        turnIntoToggle(editor, blockNodeKey);
        break;
      default:
        break;
    }
  };

  const handleTextColor = (color) => {
    applyBlockTextColor(editor, blockNodeKey, color);
    closePopover();
  };

  const handleBgColor = (color) => {
    applyBlockBackgroundColor(editor, blockNodeKey, color);
    closePopover();
  };

  if (activeSubmenu === 'turnInto') {
    return (
      <div className="block-action-menu-popover">
        <button
          type="button"
          className="block-action-back-btn"
          onClick={() => setActiveSubmenu(null)}
        >
          ← Back
        </button>
        <TurnIntoSubmenu
          currentBlockType={blockType}
          onSelect={handleTurnInto}
        />
      </div>
    );
  }

  if (activeSubmenu === 'color') {
    return (
      <div className="block-action-menu-popover">
        <button
          type="button"
          className="block-action-back-btn"
          onClick={() => setActiveSubmenu(null)}
        >
          ← Back
        </button>
        <BlockColorSubmenu
          onTextColor={handleTextColor}
          onBgColor={handleBgColor}
        />
      </div>
    );
  }

  return (
    <div className="block-action-menu-popover">
      <button type="button" className="block-action-item" onClick={handleDelete}>
        <Trash2 size={16} strokeWidth={1.5} />
        <span>Delete</span>
      </button>
      <button type="button" className="block-action-item" onClick={handleDuplicate}>
        <CopyPlus size={16} strokeWidth={1.5} />
        <span>Duplicate</span>
      </button>
      <button type="button" className="block-action-item" onClick={handleCopy}>
        <Copy size={16} strokeWidth={1.5} />
        <span>Copy</span>
      </button>
      <div className="block-action-divider" />
      <button type="button" className="block-action-item" onClick={() => setActiveSubmenu('turnInto')}>
        <ArrowRightLeft size={16} strokeWidth={1.5} />
        <span>Turn into</span>
        <span className="block-action-chevron">›</span>
      </button>
      <button type="button" className="block-action-item" onClick={() => setActiveSubmenu('color')}>
        <Palette size={16} strokeWidth={1.5} />
        <span>Color</span>
        <span className="block-action-chevron">›</span>
      </button>
    </div>
  );
};

export default BlockActionMenuPopover;
